<template>
    <div @mouseover="enter" @mouseleave="leave" id="head">
        <a :href="link" target="_blank" @click="leave">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.5 45.5">
                <title>Facebook</title>
                <circle id="FacebookRing" cx="22.75" cy="22.75" r="22"/>
                <path id="FacebookLogo" d="M26.3,38H21.4V26.5H19v-4h2.4V20.1c0-3.2,1.4-5.2,5.3-5.2H30v4H28c-1.5,0-1.6.6-1.6,1.6v2H30l-.4,4H26.3V38Z" transform="translate(-2.25 -2.25)"/>
            </svg>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        link: String,
        darkMode: Boolean
    },
    methods: {
        enter: function () {
            if (this.darkMode) {
                document.getElementById("FacebookLogo").style.fill = "#FFFFFF";
                // document.getElementById("FacebookRing").style.stroke = "#FFFFFF";
            }
        },
        leave: function () {
            if (this.darkMode) {
                document.getElementById("FacebookLogo").style.fill = "#000000";
                // document.getElementById("FacebookRing").style.stroke = "#000000";
            }            
            // document.getElementById("FacebookRing").style.fill = "none";
        }
    },
    mounted() {
        // set light mode attributes, icon dark by default
        if (!this.darkMode) {
            // document.getElementById("FacebookRing").style.stroke = "#FFFFFF";
            document.getElementById("FacebookLogo").style.fill = "#FFFFFF";
        }
        // document.getElementById("FacebookRing").style.fill = "none";
        document.getElementById("FacebookRing").style.stroke = "none";
    }
}
</script>

<style scoped>
#head {
    height: 35px;
    width: 35px;
    margin-right: 5px;
    /* margin-bottom: 10px; */
}
a > svg > #FacebookRing {
    fill: #4267B2;
    opacity: 0;
    stroke: none;
    stroke-width: 1.5px;
    transition: opacity .2s linear;
}
svg:hover > #FacebookRing {
    opacity: 1;
}
#FacebookLogo {
    fill-rule: evenodd;
}
svg {
    width: 35px;
    position: absolute;
}
</style>